import { QueryClient } from '@tanstack/react-query'
import { backoffMs, rateLimitRetryAfterSeconds } from '@/shared/lib/rateLimit'

/**
 * Defaults globaux TanStack Query.
 * - `staleTime` 5 min : evite refetch agressif sur remount/navigation.
 * - `gcTime` 10 min : conserve cache assez longtemps pour back/forward navigation.
 * Override par feature au besoin (ex: brand 1h via `staleTime: 60*60*1000`, feature-flags 60s).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const retryAfter = rateLimitRetryAfterSeconds(error)
        return failureCount < 1 && retryAfter !== undefined && retryAfter !== null && retryAfter <= 30
      },
      retryDelay: (failureCount, error) => backoffMs(error, failureCount),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
    mutations: {
      retry: false,
    },
  },
})

declare global {
  interface Window {
    __CSE_QUERY_CLIENT__?: QueryClient
  }
}

if (typeof window !== 'undefined') {
  window.__CSE_QUERY_CLIENT__ = queryClient
}
